import Back from "../../assets/icons/back.svg";
import { Link } from "react-router-dom";
import InviteMemberCard from "./inviteMemberCard";

const InviteMember = () => {
  return (
    <div className="grid gap-2 space-x-3">
      <div className="flex pt-3 pl-3">
        <Link to="/main/profile/manage-team" className="no-underline">
          <div className="flex items-center">
            <img src={Back} alt="Edit Icon" className="mr-1" />
            <span className="text-lg font-bold text-black ml-1">
              Invite Member
            </span>
          </div>
        </Link>
      </div>
      <div>
        <InviteMemberCard buttonTitle="Send invitation" buttonType="invite" />
        {/* <InvitationSentCard /> */}
      </div>
      <div></div>
    </div>
  );
};
export default InviteMember;
